// utils/zIndexManager.js
let currentZ = 50000; // safely above most UI layers
export function getNextZ() {
  return ++currentZ;
}
